module.exports = __webpack_public_path__ + "img/MMN.7dcaeaeb.svg";